import React, { useRef, useState } from 'react';
import './data-picker.scss';
import { differenceInYears, format, isSameDay, isValid, parse, sub } from 'date-fns';
import { MonthPicker } from './month-picker';
import { DayPicker } from './day-picker';
import { YearPicker } from './year-picker';
import clsx from 'clsx';
import './data-picker.scss';

type DatePicker = React.FC<{
    className: string;
    dob: string | null;
    isRequireChanges: boolean;
    onChangeDate?: (date: string) => void;
}>;

export const DataPicker: DatePicker = ({ className, dob, isRequireChanges, onChangeDate }) => {
    const dateFormat = 'yyyy-MM-dd';
    const adulthood = 18;
    const [tempDate, setDate] = useState<Date>(getDefaultDate());
    const dayPickerRef = useRef<any>(null)
    const monthPickerRef = useRef<any>(null)
    const yearPickerRef = useRef<any>(null)

    function getDefaultDate(): Date {
        const date = new Date();
        if (dob)
            return parse(dob, dateFormat, date);
        date.setDate(1);
        date.setMonth(0);
        date.setFullYear(date.getFullYear() - adulthood);
        return date;
    }

    function didChange(date: Date, prev: Date): Date {
        if (
            (
                !isSameDay(date, prev) &&
                isRequireChanges
            ) ||
            !isRequireChanges
        ) onChangeDate?.(format(date, 'yyyy-MM-dd'));
        return date;
    }

    const scrollPickersToSelection = (date: Date) => {
        dayPickerRef
            .current
            ?.scrollTo(
                date.getDate() - 1
            )
        monthPickerRef
            .current
            ?.scrollTo(
                date.getMonth()
            )
        yearPickerRef
            .current
            ?.scrollTo(
                new Date()
                .getFullYear() -
                18 -
                date
                    .getFullYear()
            )
    }

    const correctDate = (date: Date) => {
        const today = new Date()
        if (differenceInYears(today, date) < adulthood) {
            const correctedDate = sub(today, {
                years: adulthood
            })
            date.setDate(
                correctedDate.getDate()
            );
            date.setMonth(
                correctedDate.getMonth()
            );
            date.setFullYear(
                correctedDate.getFullYear()
            );
        }
    }

    function setDay(val: number) {
        setDate((date) => {
            const prev =
                new Date(tempDate.getTime())
            date.setDate(val)
            correctDate(date)
            scrollPickersToSelection(date)
            return didChange(date, prev)
        });
    }

    function setMonth(val: number) {
        setDate((date) => {
            const prev =
                new Date(tempDate.getTime())
            date.setMonth(val)
            correctDate(date)
            scrollPickersToSelection(date)
            return didChange(date, prev)
        });
    }

    function setYear(val: number) {
        setDate((date) => {
            const prev =
                new Date(tempDate.getTime())
            date.setFullYear(val)
            correctDate(date)
            scrollPickersToSelection(date)
            return didChange(date, prev)
        });
    }

    return (
        <div className={clsx('datepicker', className)}>
            <div className="embla">
                <DayPicker
                    dob={dob}
                    onInit={(api) => dayPickerRef.current = api}
                    onChange={setDay} />
                <MonthPicker
                    dob={dob}
                    onInit={(api) => monthPickerRef.current = api}
                    onChange={setMonth} />
                <YearPicker
                    dob={dob}
                    onInit={(api) => yearPickerRef.current = api}
                    onChange={setYear} />
            </div>
        </div>
    );
};
